import React from 'react';
import { Route } from 'react-router-dom';
import { UnsupportedProfile } from '../pages/UnsupportedProfile/UnsupportedProfile';
import { LegacyRedirect } from '../pages/LegacyRedirect/LegacyRedirect';
import { adminRoutes } from '../workspaces/admin/adminRoutes';
import { operatorRoutes } from '../workspaces/operator/operatorRoutes';
import { sellerRoutes } from '../workspaces/seller/sellerRoutes';
import { staffRoutes } from '../workspaces/staff/staffRoutes';

const ROUTES_BY_ROLE = {
  admin: adminRoutes,
  operator: operatorRoutes,
  seller: sellerRoutes,
};

/** A profile with no workspace here and none in the old front either. */
export const unsupportedRoutes = <Route path="*" element={<UnsupportedProfile />} />;

/** A profile whose workspace is in the front this one is replacing. */
export const legacyRoutes = <Route path="*" element={<LegacyRedirect />} />;

/**
 * Which tree of pages a session gets.
 *
 * Its own module, and a plain function, because `AppRouter` owns its
 * `BrowserRouter` and so cannot be rendered in a test — while this decision is
 * exactly the one worth asserting.
 *
 * **The legacy handover replaces the role's tree; it is never mounted beside
 * it.** React Router does not resolve by declaration order: it scores every
 * branch and sorts, where a static segment is worth 10 and a splat costs 2. So
 * a `path="*"` sitting next to `adminRoutes` loses to `/dashboard`, and an
 * account on the checkout plan would walk straight into the workspace it is
 * being taken out of — while the handover screen showed up only on addresses
 * that do not exist. Which is worse than doing nothing, and looks like it works.
 *
 * @param {object} params
 * @param {'admin'|'operator'|'seller'|null} params.role
 * @param {boolean} params.isStaff
 * @param {'admin_checkout'|'driver'|null} params.legacyProfile
 * @returns {React.ReactNode}
 */
export const pickRoutes = ({ role, isStaff, legacyProfile }) => {
  if (legacyProfile) return legacyRoutes;

  // Staff is not a profile of its own: it is an admin account with the whole
  // platform in scope, so it mounts the admin tree with its own screens added.
  if (role === 'admin' && isStaff) return staffRoutes;

  return ROUTES_BY_ROLE[role] || unsupportedRoutes;
};
